import { render, staticRenderFns } from "./bet.vue?vue&type=template&id=1738fbb4&scoped=true"
import script from "./bet.vue?vue&type=script&lang=js"
export * from "./bet.vue?vue&type=script&lang=js"
import style0 from "./bet.vue?vue&type=style&index=0&id=1738fbb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1738fbb4",
  null
  
)

export default component.exports